import { Answer } from "./answer";
import { Contact } from "./contact";
import { Note } from "./note";
import { DEFAULT_REGION } from "./sentinels";
export class ReferenceBusiness {
    constructor() {
        this.className = "ReferenceBusiness";
        this.id = undefined;
        this.businessContactEntity = new Contact();
        this.tenantId = null;
        this.ownerId = null;
        this.notes = [];
        this.draftNote = "";
        this.summary = "";
        this.regions = [];
        this.answers = [];
        this.dateAdded = new Date();
        this.updatedAt = new Date();
        this.createdBy = "";
        this.updatedBy = "";
    }
    static empty() {
        return new ReferenceBusiness();
    }
    clone() {
        return ReferenceBusiness.clone(this);
    }
    static clone(source) {
        var theClone = new ReferenceBusiness();
        theClone.id = source.id;
        theClone.businessContactEntity = Contact.clone(source.businessContactEntity);
        theClone.notes = (source.notes || []).map((n) => Note.clone(n));
        theClone.draftNote = source.draftNote;
        theClone.summary = source.summary;
        theClone.tenantId = source.tenantId;
        theClone.regions = (source.regions || []).slice();
        if (theClone.regions.length === 0) {
            theClone.regions = [DEFAULT_REGION];
        }
        theClone.ownerId = source.ownerId ?? null;
        theClone.dateAdded = source.dateAdded ? new Date(source.dateAdded) : new Date();
        theClone.updatedAt = source.updatedAt ? new Date(source.updatedAt) : new Date();
        theClone.updatedBy = source.updatedBy;
        theClone.createdBy = source.createdBy;
        theClone.answers = (source.answers || []).map((a) => Answer.clone(a));
        return theClone;
    }
    static load(source) {
        var theClone = new ReferenceBusiness();
        theClone.id = source.id;
        theClone.businessContactEntity = Contact.load(source.businessContactEntity || {});
        theClone.notes = (source.notes || []).map((n) => Note.load(n));
        theClone.draftNote = source.draftNote;
        theClone.summary = source.summary;
        theClone.tenantId = source.tenantId;
        theClone.regions = (source.regions || []).slice();
        if (theClone.regions.length === 0) {
            theClone.regions = [DEFAULT_REGION];
        }
        theClone.ownerId = source.ownerId ?? null;
        theClone.dateAdded = source.dateAdded;
        theClone.updatedAt = source.updatedAt;
        theClone.updatedBy = source.updatedBy;
        theClone.createdBy = source.createdBy;
        theClone.answers = (source.answers || []).map((a) => Answer.load(a));
        return theClone;
    }
    get preferredEntityName() {
        const hasBusiness = this.businessContactEntity &&
            this.businessContactEntity.name &&
            this.businessContactEntity.name !== "";
        if (hasBusiness) {
            return this.businessContactEntity.name;
        }
        return "(no name)";
    }
    get preferredName() {
        const hasBusiness = this.businessContactEntity &&
            this.businessContactEntity.name &&
            this.businessContactEntity.name !== "";
        if (hasBusiness) {
            return this.businessContactEntity.name;
        }
        return "(no name)";
    }
    matches(matchText) {
        return this.preferredName.toLowerCase().indexOf(matchText) >= 0;
    }
}
//# sourceMappingURL=reference-business.js.map